import { css } from "@compiled/react";

import { TypographyStyles } from "@/libraries/wpl/foundations/src";

import { useStylePropertyVariableValueFromParent } from "../../../hooks/use-style-property-variable-value-from-parent";

type TextAlignment = "left" | "center" | "right";

export interface UniformTextProps {
    text: string;
    style:
        | "body-lg"
        | "body-md"
        | "body-sm"
        | "body-lg bold"
        | "body-md bold"
        | "body-sm bold"
        | "card-title"
        | "card-title-sm"
        | "fine-print"
        | "eyebrow-lg"
        | "eyebrow-md"
        | "eyebrow-sm"
        | "callout"
        | "callout-lg";
    alignment?: TextAlignment;
    headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
    tagType?: "p" | "dt" | "dd";
}

const UniformText = ({
    text,
    style = "body-lg",
    alignment = "left",
    headingLevel,
    tagType: Component = "p"
}: UniformTextProps) => {
    const [textRef, textColor] = useStylePropertyVariableValueFromParent(
        "--dxp-container-text-color"
    );

    const alignmentStyle = css({
        textAlign: alignment
    });
    const boldStyling = css({
        "&.bold": {
            fontWeight: 700
        }
    });
    const resetMargin = css({
        margin: 0
    });

    return (
        <TypographyStyles>
            <Component
                ref={textRef as React.LegacyRef<HTMLParagraphElement>}
                className={style}
                css={[
                    style.includes("bold") && boldStyling,
                    resetMargin,
                    alignmentStyle
                ]}
                style={textColor ? { color: textColor } : undefined}
                role={headingLevel ? `heading` : undefined}
                aria-level={headingLevel}
            >
                {text}
            </Component>
        </TypographyStyles>
    );
};

export default UniformText;
